import axios from "axios";
import { useQuery } from "react-query";

const apiBaseUrl =
  process.env.REACT_APP_API_BASEURL +
  "/BusinessLicensePermits/BusinessLicenseAndPermitType";

export interface BusinessLicensePermitType {
  busLicensePermitTypeId: number;
  busLicensePermitTypeName: string;
  createdDate?: string | null;
  createdBy?: string | null;
  modifiedDate?: string | null;
  modifiedBy?: string | null;
  isActive?: boolean | null;
}

export const getBusinessLicensePermitType = async (): Promise<
  BusinessLicensePermitType[]
> => {
  const response = await axios.get<BusinessLicensePermitType[]>(apiBaseUrl);

  return Array.isArray(response.data) ? response.data : [];
};

export const useGetBusLicensePermitType = (enabled: boolean = true) => {
  return useQuery<BusinessLicensePermitType[]>(
    ["GetBusinessLicensePermitType", "v2"],
    getBusinessLicensePermitType,
    {
      refetchOnWindowFocus: false,
      enabled,
      initialData: [],
    },
  );
};
